/* eslint-disable react/react-in-jsx-scope */
export default function ComputerIcon({iconStyle})  {
    return (
        <svg style={iconStyle} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M16.6667 15.0002L18.3333 13.3335V3.3335H1.66667V13.3335L3.33333 15.0002H0V16.6668H20V15.0002H16.6667ZM3.33333 5.00016H16.6667V13.3335H3.33333V5.00016Z" fill="#676879"/>
        </svg>
    );
};
